export default "__VITE_ASSET__DH59RGzJ__"